/*
 * Textbox with label
 */
import React from "react";

import TxtBox from "components/Custom/TxtBox";

const TxtRow = ({
  id,
  label,
  type = "text",
  required = false,
  defaultValue = "",
  disabled = false,
  rows,
  placeholder,
  value,
  onChange,
  onBlur,
  error,
  helperText,
  onKeyPress,
  autoComplete,
}: any) => {
  return (
    <>
      <label className={required ? "red" : ""}>
        {label}
        {required && <span className="red">{" *"}</span>}
      </label>
      {value ? (
        <TxtBox
          id={id}
          type={type}
          placeholder={placeholder ? placeholder : label}
          value={value}
          disabled={disabled}
          rows={rows}
          className={rows ? "multiLine" : ""}
          onChange={onChange}
          onBlur={onBlur}
          error={error}
          helperText={helperText}
          onKeyPress={onKeyPress}
        />
      ) : (
        <TxtBox
          id={id}
          type={type}
          placeholder={placeholder ? placeholder : label}
          defaultValue={defaultValue}
          disabled={disabled}
          rows={rows}
          className={rows ? "multiLine" : ""}
          onChange={onChange}
          onBlur={onBlur}
          error={error}
          helperText={helperText}
          onKeyPress={onKeyPress}
        />
      )}
    </>
  );
};

export default TxtRow;
